import { Editor, Range, Transforms } from 'slate'
import hotkeys from 'slate-hotkeys'

import { BASE_BLOCK_ELEMENT_TYPES } from './serialization'
import { isButton, isButtonFocused } from './buttons'

export function getBaseBlockElementType(editor, selection) {
  return BASE_BLOCK_ELEMENT_TYPES.find((type) => {
    const [node] = Editor.nodes(editor, { match: (node) => node.type === type, at: selection })
    return Boolean(node)
  })
}

export function baseBlockElementsEventHandler(editor, event) {
  if (hotkeys.isSplitBlock(event)) {
    if (Range.isExpanded(editor.selection)) Editor.deleteFragment(editor)
    const baseBlockElementType = getBaseBlockElementType(editor, editor.selection)
    const isHeadline = baseBlockElementType && baseBlockElementType.includes('headline')

    if (isHeadline) {
      Editor.insertBreak(editor)
      // Setting the newly created line to paragraph.
      Transforms.setNodes(editor, { type: 'paragraph' })

      event.preventDefault()
    } else if (isButtonFocused(editor)) {
      const [selectionStart, selectionEnd] = Range.edges(editor.selection)
      const [[buttonNode, buttonPath]] = Editor.nodes(editor, { match: isButton })
      const isAtStartOfButton = Editor.isStart(editor, selectionStart, buttonPath)
      const isAtEndOfButton = Editor.isEnd(editor, selectionEnd, buttonPath)

      if (isAtStartOfButton) {
        Transforms.insertNodes(editor, { type: 'paragraph', align: buttonNode.align, children: [{ text: '' }] })
        Transforms.move(editor)
        event.preventDefault()
      } else if (isAtEndOfButton) {
        Transforms.insertNodes(editor, { type: 'paragraph', align: buttonNode.align, children: [{ text: '' }] })
        event.preventDefault()
      }
    }
  }
}
